const styles = (theme) => ({
    container: {
        width: '100%',
        height: '100%',
        overflow: 'auto',
    },
    values: {
        padding: 0,
    },
    summaryExpanded: {
        margin: '0 !important',
    },
    letterSection: {
        backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
    },
    inactiveCircle: {
        background: '#246AA7',
        width: theme.spacing(4),
        height: theme.spacing(4),
        color: 'white',
    },
    activeCircle: {
        background: '#A40943',
        width: theme.spacing(4),
        height: theme.spacing(4),
        color: 'white',
    },
    panel: {
        boxShadow: 'none',
    },
    details: {
        flexDirection: 'column',
    },
    letter: {
        marginBottom: '1px',
    },
});

export default styles;
